// 公開中のホワイトペーパーのみをフィルタリングするユーティリティ
import { AVAILABLE_WHITEPAPERS } from '../config/whitepaper-availability.js';

/**
 * 関連ホワイトペーパーリストから公開中のもののみを抽出
 * @param {string[]} relatedWhitepapers - 関連ホワイトペーパーのIDリスト
 * @returns {string[]} - 公開中のホワイトペーパーIDのみ
 */
export function filterAvailableWhitepapers(relatedWhitepapers) {
  if (!relatedWhitepapers || !Array.isArray(relatedWhitepapers)) {
    return [];
  }

  return relatedWhitepapers.filter(wpId =>
    AVAILABLE_WHITEPAPERS.includes(wpId)
  );
}

/**
 * ホワイトペーパーが公開中かチェック
 * @param {string} wpId - ホワイトペーパーID
 * @returns {boolean} - 公開中ならtrue
 */
export function isWhitepaperAvailable(wpId) {
  return AVAILABLE_WHITEPAPERS.includes(wpId);
}

/**
 * 記事データの関連ホワイトペーパーをフィルタリング
 * @param {Object} article - 記事データ
 * @returns {Object} - フィルタリング済みの記事データ
 */
export function filterArticleWhitepapers(article) {
  if (!article) return article;

  return {
    ...article,
    relatedWhitepapers: filterAvailableWhitepapers(article.relatedWhitepapers)
  };
}